export default __webpack_public_path__ + "static/media/V_wdt_c_cap_2.432b9679.mp3";